import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ComponentPortal, ToastrService } from 'ngx-toastr';
import { Cliente } from 'src/app/app.domain.models/cliente';
import { ClienteApiService } from 'src/app/app.domain.services/cliente.api.service';

@Component({
    selector: 'app-modal-fecha-identificacion-erronea',
    templateUrl: './modal-fecha-identificacion-erronea.component.html',
    styleUrls: ['./modal-fecha-identificacion-erronea.component.scss']
})
export class ModalFechaIdentificacionErroneaComponent {
    portal!: ComponentPortal<any>;
    mostrarBtnFooter: boolean = true;

    cliente!: Cliente;

    fechaPoliza!: string;
    fechaDocumento!: string;

    constructor(
        public dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private toastr: ToastrService,
        private clienteService: ClienteApiService,
    ) { }

    ngOnInit() {
        this.mostrarBtnFooter = this.data.mostrarBtnFooter;
        this.fechaDocumento = this.data.fechaDNI[0];
        this.fechaPoliza = this.data.fechaPoliza;
        this.cliente = this.data.cliente;
    }

    cerrarModalGeneric(): void {
        this.dialogRef.close();
    }

    aplicarFechaDNI(): void {
        const partes = this.fechaDocumento.split('/');
        if (partes.length === 3) {
            const fechaCorrecta = `${partes[1]}/${partes[0]}/${partes[2]}`;
            this.cliente.fechaNacimiento = new Date(fechaCorrecta);
            this.clienteService.actualizar(this.cliente);
            this.toastr.success('Fecha de nacimiento aplicada a la póliza con éxito.');
            this.dialogRef.close('fechaCambiada');
        } else {
            this.toastr.error('Formato de fecha no reconocido.');
        }
    }
}
